import React, { useMemo } from 'react';

import { BaseIcon } from 'src/components/BaseIcon';
import { TMeasurementNotificationListItemProps } from 'src/components/MeasurementNotificationList/MeasurementNotificationList.types';
import { MeasurementNotificationPhrase } from 'src/components/MeasurementNotificationList/MeasurementNotificationListHelperComponents';
import { UserRequestsStatus } from 'src/graphql';

import s from './MeasurementNotificationList.module.scss';

export const MeasurementNotificationListItem: React.FC<TMeasurementNotificationListItemProps> = ({
  notification,
}) => {
  const childrenPhrase = useMemo(() => notification.children?.map((item) => item.name).join(', '), [
    notification,
  ]);

  if (notification.status !== UserRequestsStatus.Received) return null;

  return (
    <li>
      <div className={s.content}>
        {childrenPhrase && (
          <MeasurementNotificationPhrase
            childrenPhrase={childrenPhrase}
            assetName={notification.asset.name}
            userName={notification.userName}
          />
        )}
      </div>
      <button
        type="button"
        title="Accept"
        onClick={() => {
          //console.log('acceptSingleItem');
        }}>
        <BaseIcon icon="check-mark" size={12} />
      </button>
      <button
        type="button"
        title="Reject"
        onClick={() => {
          //console.log('reject');
        }}>
        <BaseIcon icon="close" size={8} />
      </button>
    </li>
  );
};
